import React, { useEffect } from 'react';

interface MatomoAnalyticsProps {
  embedCode?: string;
  enableAnalytics?: boolean;
}

const MatomoAnalytics: React.FC<MatomoAnalyticsProps> = ({ 
  embedCode, 
  enableAnalytics = true 
}) => {
  useEffect(() => {
    // Only load Matomo if analytics is enabled and we have the embed code
    if (!enableAnalytics || !embedCode) {
      return;
    }

    // Sanitize the embed code
    let scriptContent = embedCode;

    // Remove script tags if present
    if (scriptContent.includes('<script')) {
      const match = scriptContent.match(/<script[^>]*>([\s\S]*?)<\/script>/i);
      if (match && match[1]) {
        scriptContent = match[1];
      }
    }

    // Remove HTML comments
    scriptContent = scriptContent.replace(/<!--[\s\S]*?-->/g, '');

    // Create a script element with the sanitized embed code
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = scriptContent;
    
    // Append to head
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      // Remove the script when component unmounts
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [embedCode, enableAnalytics]);

  // This component doesn't render anything visible
  return null;
};

export default MatomoAnalytics;
